module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGames/nfl/survive-fd844e6995c12e33b54effd490cc49cc.svg";